import { RiArrowGoBackFill } from "react-icons/ri";
import classes from "./BreadCrumb.module.css";
import CommonButton from "../CommonButton/CommonButton";
import { useNavigate } from "react-router-dom";

const BreadCrumb = ({ cancelText, createText, onCreate, rejectText, onReject, disableCreateButton }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // -1 navigates to the previous page
  };
  return (
    <div
      className={`d-flex justify-content-between align-items-center ${classes.wrapper}`}
    >
      <div
        className={`${classes.backButton} d-flex align-items-center gap-3`}
        role="button"
        onClick={handleGoBack}
      >
        <RiArrowGoBackFill size={18} />
        Go back
      </div>
      <div className="d-flex align-items-center gap-3">
        {cancelText && <CommonButton
          text={cancelText}
          className={classes.cancelButton}
          onClick={handleGoBack}
        />}{" "}
        {createText && <CommonButton text={createText} onClick={onCreate} disabled={disableCreateButton}/>}
        {rejectText && <CommonButton className={classes.rejectButton} text={rejectText} onClick={onReject} />}
      </div>
    </div>
  );
};
export default BreadCrumb;
